<template>
  <div style="min-height:100vh">
    <v-app-bar
      app
      flat
      color="transparent"
      collapse-on-scroll
    >
      <v-toolbar-title>
        My Trips
      </v-toolbar-title>

      <v-spacer />

      <v-btn
        v-if="$currentUser"
        color="primary"
        depressed
        :to="{ name: 'trip-new' }"
        class="mr-4"
      >
        <v-icon left>
          mdi-plus
        </v-icon>
        Trip
      </v-btn>

      <the-user-menu />
    </v-app-bar>

    <v-content>
      <v-container
        fluid
        grid-list-lg
      >
        <v-row>
          <v-col>
            <v-chip-group
              v-model="currentFilter"
              mandatory
              active-class="primary--text"
              @change="onFilterChange"
            >
              <v-chip
                v-for="filter in allFilters"
                :key="filter"
                :value="filter"
                filter
                class="text-capitalize"
              >
                {{ filter }}
                <span class="caption ml-2">
                  ({{ tripsCountByFilter[filter] }})
                </span>
              </v-chip>
            </v-chip-group>
          </v-col>
        </v-row>

        <v-row v-if="$vuetify.breakpoint.smAndUp">
          <v-col
            v-for="trip in filteredTrips.models"
            :key="`trip-${trip.id}`"
            cols="12"
            sm="6"
            md="4"
            lg="3"
            xl="2"
          >
            <trip-card :trip="trip" />
          </v-col>

          <v-col
            v-if="!myTrips.length"
            cols="12"
            class="text-center title"
          >
            Hey you don't have any trip yet,
            click on the button at the top right and create one!
          </v-col>
        </v-row>

        <v-row v-else>
          <v-col>
            <v-slide-group>
              <v-slide-item
                v-for="trip in filteredTrips.models"
                :key="`trip-${trip.id}`"
              >
                <trip-card
                  :trip="trip"
                  class="mr-4"
                  style="width: 80vw"
                />
              </v-slide-item>
            </v-slide-group>
          </v-col>
        </v-row>
      </v-container>
    </v-content>
  </div>
</template>

<script>
import TheUserMenu from '@/components/TheUserMenu'
import TripCard from '@/components/TripCard'
import Trips from '@/models/Trips'

export default {
  name: 'Trips',
  components: {
    TheUserMenu,
    TripCard
  },
  data () {
    return {
      allFilters: [
        'current',
        'upcoming',
        'past',
        'all'
      ],
      currentFilter: 'current',
      myTrips: new Trips(),
      tripsCountByFilter: {
        current: 0,
        upcoming: 0,
        past: 0,
        all: 0
      },
      visitedCountries: new Set()
    }
  },
  computed: {
    filteredTrips () {
      return this.getFilteredTrips(this.currentFilter)
    }
  },
  watch: {
    $currentUser (newVal) {
      if (newVal) {
        this.loadData()
      }
    }
  },
  mounted () {
    if (this.$currentUser) {
      this.loadData()
    }
  },
  methods: {
    async loadData () {
      await this.myTrips.fetch({
        where: [
          [ `users.${this.$currentUser.id}`, '>', '' ]
        ]
      })

      this.myTrips.sort('startDate')

      // Count trips by status/filter
      for (let filter of this.allFilters) {
        this.tripsCountByFilter[filter] = this.getFilteredTrips(filter).length
      }

      if (this.$route.query.f) {
        // if there is a query parameter, respect it
        this.currentFilter = this.$route.query.f
      } else if (this.tripsCountByFilter.current === 0) {
        // else if there aren't any current trips, then show upcoming by default
        this.currentFilter = 'upcoming'
      }

      this.visitedCountries.clear()

      for (const trip of this.myTrips.models) {
        for (const country of trip.countries) {
          // document.getElementById(country).style.fill = accent
          this.visitedCountries.add(country)
        }
      }
    },
    /**
     * @typedef {import('../models/Trip').default} Trip
     * @param {string} filter
     * @return {Trip[]}
     */
    getFilteredTrips (filter = 'all') {
      if (filter === 'all') {
        return this.myTrips
      } else {
        const now = new Date().toISOString().slice(0, 10)

        return this.myTrips.filter((trip) => {
          const start = trip.startDate ? trip.startDate : null
          const end = trip.endDate ? trip.endDate : null

          if (filter === 'upcoming') {
            return !start || start > now
          } else if (filter === 'past') {
            return !!end && end < now
          } else if (filter === 'current') {
            return !!start && !!end &&
              start <= now && end >= now
          } else {
            return false
          }
        })
      }
    },
    onFilterChange (filter) {
      this.$router.replace({
        name: this.$route.name,
        query: {
          ...this.$route.query, f: filter
        }
      })
    }
  }
}
</script>

<style scoped>
.v-toolbar.v-toolbar--collapsed {
  left: auto !important;
}
</style>
